import React from 'react'
import MailIcon from '@mui/icons-material/Mail'
import { Link } from 'react-router-dom'
import { CONTACT_US_FLATPAGE_URL } from '../../../urls'
import PinterestIcon from '@mui/icons-material/Pinterest'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import { SiteQueryResult } from '@graphql/queries/__generated__/site.generated'
import TumblrIcon from '@icons/TumblrIcon'
import { useTranslation } from 'react-i18next'

const getSocialIcon = (name: string) => {
  if (name.toLowerCase().includes('pinterest')) {
    return <PinterestIcon className='mr-6' fontSize='large' />
  } else if (name.toLowerCase().includes('facebook')) {
    return <FacebookIcon className='mr-6' fontSize='large' />
  } else if (name.toLowerCase().includes('instagram')) {
    return <InstagramIcon className='mr-6' fontSize='large' />
  } else if (name.toLowerCase().includes('tumblr')) {
    return <TumblrIcon viewBox='0 0 504 504' className='mr-6' sx={{ fontSize: '20px' }} />
  }
}

interface FooterTopSocialLinksProps {
  socialLinks: SiteQueryResult['data']['siteSettings']['site']['footerBlocks'][0]['links']

  handleContactUs(): void
}

const FooterTopSocialLinks: React.FC<FooterTopSocialLinksProps> = ({ socialLinks, handleContactUs }) => {
  const { t } = useTranslation()
  return (
    <ul
      className='hidden sm:flex h-50 items-center justify-center bg-white
			border-t border-solid border-gray-400 border-0 p-0 m-0 list-none text-13'
    >
      {socialLinks.map((link, idx) => (
        <li key={idx} className='mx-14 flex items-center'>
          {getSocialIcon(link.linkAddress)}
          <a href={link.linkAddress} target='_blank' className='no-underline hover:underline'>
            @{link.linkText.toLowerCase()}
          </a>
        </li>
      ))}
      <li className='mx-14 flex items-center'>
        <MailIcon className='mr-6' fontSize='large' />
        <Link
          to={CONTACT_US_FLATPAGE_URL}
          onClick={e => {
            e.preventDefault()
            handleContactUs()
          }}
          className='no-underline hover:underline'
        >
          {t('emailUs', 'Email Us')}
        </Link>
      </li>
    </ul>
  )
}

export default FooterTopSocialLinks
